<template>
    <div>
        <b-card no-body class="mb-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                    block
                    v-b-toggle.accordion-1
                    variant="light"
                    class="text-left"
                >
                    Confort
                </b-button>
            </b-card-header>
            <b-collapse
                id="accordion-1"
                accordion="my-accordion"
                role="tabpanel"
            >
                <b-card-body>
                    <div
                        v-for="(comf, index) in accesoriosData.confort"
                        :key="index"
                    >
                        <i class="fa fa-check" aria-hidden="true"></i>
                        {{ comf }}
                        <hr />
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-card no-body class="mb-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                    block
                    v-b-toggle.accordion-2
                    variant="light"
                    class="text-left"
                >
                    Seguridad
                </b-button>
            </b-card-header>
            <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
            >
                <b-card-body>
                    <div
                        v-for="(seguridad, index) in accesoriosData.seguridad"
                        :key="index"
                    >
                        <i class="fa fa-check" aria-hidden="true"></i>
                        {{ seguridad }}
                        <hr />
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-card no-body class="mb-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                    block
                    v-b-toggle.accordion-3
                    variant="light"
                    class="text-left"
                >
                    Entretenimiento
                </b-button>
            </b-card-header>
            <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
            >
                <b-card-body>
                    <div
                        v-for="(multimedia, index) in accesoriosData.multimedia"
                        :key="index"
                    >
                        <i class="fa fa-check" aria-hidden="true"></i>
                        {{ multimedia }}
                        <hr />
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-card no-body class="mb-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                    block
                    v-b-toggle.accordion-4
                    variant="light"
                    class="text-left"
                >
                    Exterior
                </b-button>
            </b-card-header>
            <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
            >
                <b-card-body>
                    <div
                        v-for="(exterior, index) in accesoriosData.exterior"
                        :key="index"
                    >
                        <i class="fa fa-check" aria-hidden="true"></i>
                        {{ exterior }}
                        <hr />
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
export default {
    computed: {
        accesoriosData() {
            return this.$store.state.fichaTecnica.vehiculo.tabs.accesorios;
        }
    }
};
</script>

<style lang="scss">
button.btn.text-left.btn-light.btn-block.collapsed {
    background: #efefef;
    color: #818181;
    font-weight: 700;
}
</style>
